import loadExtends from "./routeExtend";

import errorPage from "../components/error.vue"

function checkKeys(routes) {
  const keys = {};
  addKeys(routes, keys);

  const gtOneKeys = [];
  Object.keys(keys).forEach((key) => {
    if (keys[key] > 1) gtOneKeys.push(key);
  });
  if (gtOneKeys.length > 0) {
    throw new Error(`[routes.js] name重复：[${gtOneKeys.join(" ")}]`);
  }

  function addKeys(items, keys) {
    items.forEach((item) => {
      if (item.name) {
        if (keys[item.name]) keys[item.name]++;
        else keys[item.name] = 1;
      }
      if (item.children && item.children.length > 0) {
        addKeys(item.children, keys);
      }
    });
  }
}

//获取Vue路由字典
function getVueRouteDict(routes) {
  const config = {};

  addConfig(routes, config);

  function addConfig(items, config) {
    items.forEach((item) => {
      if (item.name) {
        config[item.name] = item;
      }
      if (item.children && item.children.length > 0) {
        addConfig(item.children, config);
      }
    });
  }

  return config;
}

//获取菜单中模块的字典
function getMenuModuleDict(menus) {
  const config = {};
  addConfig(menus, config);
  function addConfig(items, config) {
    items.forEach((item) => {
      if (item.children == undefined) {
        config[item.name] = item;
      }
      if (item.children && item.children.length > 0) {
        // item.disable = true;
        addConfig(item.children, config);
      }
    });
  }
  return config;
}

function findFirstRouteName(menus) {
  // const isPc = device === 'pc';
  // const config = {}
  return search(menus);
  //
  function search(items) {
    //
    for (let index = 0; index < items.length; index++) {
      const item = items[index];
      // if (isPc) {

      if (item.name && !item.children) {
        return item;
      } else if (item.children) {
        return search(item.children);
      } else continue;
    }
    return undefined;
  }
}


function getQueryString(url) {
  if (url) {
    url = url.substr(url.indexOf("?") + 1); //字符串截取，比我之前的split()方法效率高 
  }
  var result = {}, //创建一个对象，用于存name，和value 
    queryString = url, //location.search设置或返回从问号 (?) 开始的 URL（查询部分）。 
    re = /([^&=]+)=([^&]*)/g, //正则，具体不会用 
    m;
  while (m = re.exec(queryString)) { //exec()正则表达式的匹配，具体不会用 
    result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]); //使用 decodeURIComponent() 对编码后的 URI 进行解码 
  }
  return result;
}


async function initRoute(app) {
  //检查name是否重复
  checkKeys(app.routes);

  // let localPCLayout = app.helper.storage.getLocal(location.host + ":PCLayout");//为了大家好调试布局存入本地,真正发布时候,不会出现界面布局选择模块的

  //路由表恢复,这里面重新构成了app.routes
  //genVueRoute(app.routes, profile.menus);

  //

  //遍历所有菜单的末尾节点项,如果找不到对应路由则给出提醒
  // debugger
  let menusModuleDict = getMenuModuleDict(app.menus);
  let vueRouteDict = getVueRouteDict(app.routes);

  for (const key in menusModuleDict) {
    if (vueRouteDict[key] == undefined) {
      let route = {
        name: key,
        component: {
          render: (h) => h("h1", { style: { color: "red", padding: "10px" } }, `菜单[${key}]没有找到对应的vue路由，请检查name是否正确设置`),
        },
      };
      app.routes.push(route);
      vueRouteDict[key] = route;
    }
  }

  //对路由顶层和平行处理
  let topLevelRoutes = [];
  let childLevelRoutes = [];

  let needAdd404 = true; // 是否需要写入404页面



  let matchsroutes = []

  app.routes.forEach((route) => {
    if (route.name && !route.path) {
      route.path = `${route.name}`;
    }
    //正则匹配路由名称，匹配成功则混入对应的东西
    route.component = loadExtends(app, route);

    if (route.path) {
      if (route.path === "/*" || route.path === "*") needAdd404 = false;

      if (window.QueryDict.hasOwnProperty("fullscreen") || (route.fullscreen)) {
        if (!route.path.startsWith("/")) route.path = "/" + route.path;
      }
      // process.env
      if (menusModuleDict[route.name] && menusModuleDict[route.name].iframe) {
        let topbashhost = window.location.protocol + "//" + window.location.host;

        if (menusModuleDict[route.name].iframe.startsWith("/"))
          menusModuleDict[route.name].iframe = topbashhost + menusModuleDict[route.name].iframe;
        // 兼容处理 防止填错 iframe  卡死系统
        try {

          // let queryParams = getQueryString(search)
          let color = app.store.state.core.thema;



          // window.localCookieInstance.getJWT()
          // ${redirect_uri}?path=${path}&hash=${hash}&ssotoken=${ssotoken}`
          // debugger
          //读取当前主图色调
          // let color = app.store.state.core.thema;
          // if (search) {
          //   search += `&color=${color}&topbashhost=${topbashhost}&r=${new Date().getTime()}`;
          // } else {
          //   search += `?color=${color}&topbashhost=${topbashhost}&r=${new Date().getTime()}`;
          // }
          // iframeURL = `${origin}${pathname}${search}${hash}`
          route.component = {
            render: (h) => {
              let { hash, origin, pathname, search } = new URL(menusModuleDict[route.name].iframe);
              if (search) {
                search += `&color=${color}&topbashhost=${topbashhost}&r=${new Date().getTime()}`;
              } else {
                search += `?color=${color}&topbashhost=${topbashhost}&r=${new Date().getTime()}`;
              }
              let iframeURL = null
              let extQueryParms = getQueryString(search)
              if (extQueryParms.jwt != undefined) {
                let jwt = window.localCookieInstance.getJWT()
                // let { path } = extQueryParms
                search += `&ssotoken=${jwt}`
              } else if (pathname.endsWith("/api/core/sso_to")) {
                //如果是headcookie=true
                let extQueryParms = window.localCookieInstance.getTokenObj()
                for (const [key, val] of Object.entries(extQueryParms)) {
                  if (val)
                    search += `&${key}=${val}`
                }
              }
              iframeURL = `${origin}${pathname}${search}${hash}`
              iframeURL = encodeURI(iframeURL)
              return h("iframe", { attrs: { src: iframeURL }, style: { width: "100%", height: "100%", border: '0' } })
            }
          }
        } catch (error) {
          route.component = {
            render: (h) => h("h1", { style: { color: "red", padding: "10px" } }, `${error} : ${menusModuleDict[route.name].iframe}`),
          }
        }
      }




      if (route.isPublic || (route.name && (app.store.state.core.user.isAdmin || menusModuleDict[route.name] || app.userPids.includes(route.name)))) {
        //因为权限已经有了这时候已经可以加入这个路由了
        if (route.path.startsWith("/"))
          topLevelRoutes.push(route);
        else
          childLevelRoutes.push(route);

        matchsroutes.push(route)
      }
      // else {
      //   // console.log("NODE_ENV=", process.env.NODE_ENV);
      //   if (route.isPublic)
      //   childLevelRoutes.push(route);
      // }
    }
  });

  // 为true加入404页面
  if (needAdd404) {
    topLevelRoutes.push(
      {
        path: "/404",
        component: errorPage
        // component: () => import("../components/error.vue"),
      },
      {
        path: "*",
        redirect: {
          path: "/404",
        }
      }
    );
  }



  if (app.menus.length == 0) return; //

  let homeMenuItem = findFirstRouteName(app.menus);

  // debugger
  let redirectobj = null;
  let lasthash = sessionStorage.getItem("core_lasthash");
  if (lasthash) {
    sessionStorage.removeItem("core_lasthash");
    window.location.hash = lasthash
  }
  //如果app.firstroute存在优先考虑处理app.firstroute
  else if (app.CORE_PROFILE && app.CORE_PROFILE.homeroute) {
    let homeRoute = matchsroutes.find((p) => p.name == app.CORE_PROFILE.homeroute.name);
    if (homeRoute) {
      redirectobj = app.CORE_PROFILE.homeroute
      if (!redirectobj.params && homeRoute.MenuParams) redirectobj.params = homeRoute.MenuParams;
    }
  }

  //如果还没有控制好首页路由那么就必须使用第一个有权限的路由了
  if (redirectobj == null) {
    redirectobj = {}
    let homeRoute = matchsroutes.find((p) => p.name == homeMenuItem.name);
    if (homeRoute) {
      //     //homeRoute.alias = '/';
      redirectobj.name = homeMenuItem.name;
      if (homeRoute.MenuParams) redirectobj.params = homeRoute.MenuParams;
    }
  }






  topLevelRoutes.unshift({
    path: "/",
    redirect: redirectobj,
    children: childLevelRoutes,
  });

  app.routes = topLevelRoutes;

  //app.menus = makemenusInfo(app.routes, profile.menus);

  //模块处理和过滤
  const no_hidden_routes = app.routes.filter((t) => t.hidden !== true);
  // const hidden_routes = app.routes.filter(t => t.hidden === true)

  // //必要属性设置
  // setRedirectAndComponent(no_hidden_routes, true)

  // //运行布局函数

  app.routeMenuTo = function (name) {
    // if (this.$route.name != name) {
    let item = app.routesDict[name];
    if (!item) return;
    app.router.instance.push({ name, params: item.MenuParams, query: item.MenuQuery });
  };

  app.routeMenuToBlank = function (name) {
    let item = app.routesDict[name]

    let hash = `#/${name}`
    if (item.path) hash = `#/${item.path}`
    if (item.MenuParams) {
      //【uri.hash】可用这句话来构造：this.$router.resolve({name:"core-userManager",  query:{"ff":"ggggg"}}).href
      hash = app.router.instance.resolve({ name, path: item.path, params: item.MenuParams }).href
      // Object.keys(item.MenuParams).forEach(key=>{
      //    path =  path.replace(`:${key}`,`${item.MenuParams[key]}`)
      // })
    }
    let uri = new URL(window.location)
    uri.hash = hash
    uri.searchParams.set("tabtitle", "__menuname")
    uri.searchParams.set("fullscreen", "")
    window.open(uri.href, "_blank")
  }




  app.menusDict = menusModuleDict; //菜单字典
  app.routesDict = vueRouteDict; //路由字典

  //绚烂布局
  // debugger
  app.layout.defaultLayout.layout(app, no_hidden_routes);

  console.log("菜单:", app.menus);
  console.log("菜单字典:", app.menusDict);
  console.log("路由:", app.routes);
  console.log("路由字典:", app.routesDict);

  // app.routes = no_hidden_routes;
  // console.log("");
  // app.routes.length = 0
  // if (no_hidden_routes.length > 0) {
  //     hidden_routes.push({ path: "*", hidden: true, redirect: { name: no_hidden_routes[0].name } });
  // }
  // no_hidden_routes.concat(hidden_routes).forEach(t => app.routes.push(t))
}

export default {
  initRoute,
};
